import React from 'react';
import { BrowserRouter as Router, Route, Switch, NavLink, Redirect } from 'react-router-dom';
import NavBar from './layouts/navbar';
import Landing from './pages/landing';
import { About } from './pages/about';
import { LoadData } from './pages/visualization';
import Daily from './pages/daily';

const NotMatchRoute = () => {
  return (
    <section id="notFoundPage">
      <h1>Oops! 404</h1>
      <h2>很抱歉查無您所搜尋的頁面，<br/>您可以點 <NavLink to="/">視覺化農業</NavLink> 回首頁瀏覽網站喔！</h2>
    </section>
  )
}


const routes = (
  <Router>
    <div>
      <NavBar />
      <Switch>
        <Route exact path="/" component={ Landing }></Route>
        <Route exact path="/about" component={ About }></Route>
        <Route exact path="/vegitables" component={() => <LoadData type="vegitables"/>}></Route>
        <Route exact path="/fruits" component={() => <LoadData type="fruits"/>}></Route>
        <Route exact path="/grains" component={() => <LoadData type="grains"/>}></Route>
        <Route exact path="/special" component={() => <LoadData type="special"/>}></Route>
        <Route exact path="/flowers" component={() => <LoadData type="flowers"/>}></Route>
        <Route exact path="/daily" component={ Daily }></Route>
        <Redirect from="*" to="/404" />
      </Switch>
      <Switch>
        <Route path="/404" >
          <NotMatchRoute />
        </Route>
      </Switch>
    </div>
  </Router>
);

export { routes };


// WEBPACK FOOTER //
// ./src/components/routes.js